import React, { type ReactNode } from "react";
import { Link } from "react-router-dom";

interface DocPageProps {
  title: string;
  children: ReactNode;
}

export function DocPage({ title, children }: DocPageProps) {
  return (
    <div className="mx-auto max-w-2xl px-6 py-20">
      <h1 className="border-b-2 border-ink pb-4 font-mono text-3xl font-bold uppercase tracking-[0.05em]">
        {title}
      </h1>
      <div className="mt-8 space-y-5 text-sm leading-relaxed">{children}</div>
      <hr className="mt-16 border-t-2 border-ink" />
      <p className="mt-6 font-mono text-xs uppercase tracking-wider">
        <Link to="/" className="no-underline">
          ← Back
        </Link>
      </p>
    </div>
  );
}

// Slightly tighter spacing for a section heading inside a DocPage.
export function DocHeading({ children }: { children: ReactNode }) {
  return (
    <h2 className="pt-4 font-mono text-xs font-bold uppercase tracking-[0.2em]">
      {children}
    </h2>
  );
}
